export default __webpack_public_path__ + "static/media/Broadform-Building-Insurance-Policy-April-2023.762c985c.pdf";